import Container from "components/Container";
import PageHeader from "components/Page/PageHeader";
import { Box } from "@chakra-ui/react";
import ListingPageHeaderBar from "components/Page/ListingPageHeaderBar";
import useFiltroExecucaoOrcamentaria from "../../hooks/useFiltroExecucaoOrcamentaria";
import useExecucaoOrcamentaria from "core/features/execucao-orcamentaria/hook/useExecucaoOrcamentaria";
import { useLoading } from "ui/components/GlobalLoading";
import ItemExecucaoOrcamentaria from "./../ItemExecucaoOrcamentaria";
import { ExecucaoOrcamentaria } from "core/features/execucao-orcamentaria/typings";
import { useMemo } from "react";
import InfiniteScrollCardList from "ui/components/InfiniteScrollCardList";

export default function ContentExecucaoOrcamentaria() {
  const { filtro, onChangeFiltro, setFiltro } = useFiltroExecucaoOrcamentaria();

  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useExecucaoOrcamentaria(filtro);

  const items = useMemo(() => {
    return (
      data?.pages.reduce(
        (agg: ExecucaoOrcamentaria[], item) => agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [data]);

  useLoading(isLoading);

  return (
    <>
      <Container>
        <PageHeader title="Execução orçamentária" />

        <Box>
          <ListingPageHeaderBar
            valueSearch={filtro.search || ""}
            onSearch={(v) => onChangeFiltro({ search: v })}
            showOrderByButton
            orderByOptions={[
              {
                value: "dataInicio",
                label: "Ano",
              },
              {
                value: "createdAt",
                label: "Data de criação",
              },
              {
                value: "nome",
                label: "Nome",
              },
            ]}
            orderBy={filtro.orderBy}
            onOrderByChange={(orderBy) => {
              setFiltro((state) => ({
                ...state,
                orderBy,
              }));
            }}
            orderDirection={filtro.orderDirection}
            onOrderDirectionChange={(orderDirection) => {
              setFiltro((state) => ({
                ...state,
                orderDirection,
              }));
            }}
          />
        </Box>

        <Box mt={4}>
          <InfiniteScrollCardList
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            data={items}
            hasMore={!!hasNextPage}
            onNext={fetchNextPage}
            emptyDescription="Não há execuções cadastradas"
            RenderCard={({ item }) => (
              <ItemExecucaoOrcamentaria key={item.id} item={item} />
            )}
          />
        </Box>
      </Container>
    </>
  );
}
